import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, switchMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from 'src/application/core/State';
import UserOrdersRequested from '../events/UserOrdersRequested';
import UserOrdersGetSucceed from '../events/UserOrdersGetSucceed';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> => {
    return event$.pipe(
        ofType(UserOrdersRequested.type),
        switchMap(() => {
            return backend.get(`${api()}users/${state$.value.user.customerId}/orders`).pipe(
                map((ajaxResponse: AjaxResponse) => new UserOrdersGetSucceed(ajaxResponse.response)),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            );
        })
    );
};



// WEBPACK FOOTER //
// ./src/application/order/epic/ordersGetAll.ts